import styled from 'styled-components';
export const SectionDescription = styled.div `
  margin-bottom: 16px;
`;
export const SectionHeader = styled.div `
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 24px */
  margin-top: 16px;
  margin-bottom: 12px;
`;
